import pkg from './package.json';

export const { version } = pkg;
export { WithManagedFocuser } from './src/hoc';
export * from './src/types';
